import React from 'react';
import { X } from 'lucide-react';

const ClientDetailsModal = ({ selectedClient, showViewModal, setShowViewModal }) => {
  if (!showViewModal || !selectedClient) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800">Client Details - {selectedClient.client_name}</h2>
          <button onClick={() => setShowViewModal(false)} className="text-gray-500 hover:text-gray-700">
            <X size={24} />
          </button>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">Basic Information</h3>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Client ID</label>
                    <p className="text-sm text-gray-900 font-medium">{selectedClient.client_id}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Client Name</label>
                    <p className="text-sm text-gray-900 font-medium">{selectedClient.client_name}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Contact Person</label>
                    <p className="text-sm text-gray-900">{selectedClient.contact_person}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Status</label>
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      selectedClient.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {selectedClient.status}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">Contact Information</h3>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Contact Number</label>
                    <p className="text-sm text-gray-900">{selectedClient.contact_phone}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Contact Email</label>
                    <p className="text-sm text-gray-900 break-all">{selectedClient.contact_email}</p>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold text-gray-800 mb-3 border-b pb-2">Address Information</h3>
                <div className="space-y-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Address Line 1</label>
                    <p className="text-sm text-gray-900">{selectedClient.address_line1}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Address Line 2</label>
                    <p className="text-sm text-gray-900">{selectedClient.address_line2 || 'N/A'}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">City</label>
                    <p className="text-sm text-gray-900">{selectedClient.city}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Country</label>
                    <p className="text-sm text-gray-900">{selectedClient.country}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end p-6 border-t">
          <button
            onClick={() => setShowViewModal(false)}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 font-medium"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDetailsModal;